import { render, staticRenderFns } from "./FormSopimusLaskusisalto.vue?vue&type=template&id=34e2c34d&scoped=true&"
import script from "./FormSopimusLaskusisalto.vue?vue&type=script&lang=js&"
export * from "./FormSopimusLaskusisalto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e2c34d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e2c34d')) {
      api.createRecord('34e2c34d', component.options)
    } else {
      api.reload('34e2c34d', component.options)
    }
    module.hot.accept("./FormSopimusLaskusisalto.vue?vue&type=template&id=34e2c34d&scoped=true&", function () {
      api.rerender('34e2c34d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormSopimusLaskusisalto.vue"
export default component.exports